import React from 'react';
import { IconSvgProps } from '@models/common';

const NavHistory: React.FC<IconSvgProps> = (props) => {
  const { size = 24, strokeWidth = 2, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeWidth={strokeWidth}
        d='M2 20.375v-14a2 2 0 0 1 2-2h3.172a2 2 0 0 1 1.414.586l.828.828a2 2 0 0 0 1.414.586H18a2 2 0 0 1 2 2v2M2.097 20.053 4.572 11.8a2 2 0 0 1 1.916-1.425h12.95a2 2 0 0 1 1.94 2.485l-1.5 6a2 2 0 0 1-1.94 1.515H2.336a.25.25 0 0 1-.24-.322Z'
      />
    </svg>
  );
};

export default NavHistory;
